export default __webpack_public_path__ + "static/ot_card_1-4e55bc137fbbd5214585fa8d57977c1f.png";